var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-term',_vm._g(_vm._b({on:{"update:errors":_vm.interceptErrors}},'filter-term',_vm.$props,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }